module.exports = __webpack_public_path__ + "static/media/08_profile_picture.384e5b3b.png";